import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { GuestGuard } from './core/guards/guest.guard';

export const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./features/public/public.routes').then((m) => m.PUBLIC_ROUTES),
	},
	{
		path: 'auth',
		canActivate: [GuestGuard],
		loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
	},
	{
		path: 'student',
		canActivate: [AuthGuard],
		data: { roles: ['STUDENT'] },
		loadChildren: () => import('./features/student/student.routes').then((m) => m.STUDENT_ROUTES),
	},
	{
		path: 'shop',
		canActivate: [AuthGuard],
		data: { roles: ['STUDENT'] },
		loadChildren: () => import('./features/shop/shop.routes').then((m) => m.SHOP_ROUTES),
	},
	{
		path: 'admin',
		canActivate: [AuthGuard],
		data: { roles: ['ADMIN'] },
		loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
	},
	{
		path: '**',
		redirectTo: '',
	},
];
